module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "上传中，请稍候..."
    }
  }, [_c('div', {
    staticClass: "info_case"
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px",
      "model": _vm.infoData,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "案件类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.infoData.type),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "type", $$v)
      },
      expression: "infoData.type"
    }
  }, _vm._l((_vm.typeLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约支队"
    }
  }, [_c('el-input', {
    attrs: {
      "value": "周口市公安局交通管理支队",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约大队"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectDadui
    },
    model: {
      value: (_vm.infoData.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "organizationId", $$v)
      },
      expression: "infoData.organizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时段"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectDate
    },
    model: {
      value: (_vm.dataValue),
      callback: function($$v) {
        _vm.dataValue = $$v
      },
      expression: "dataValue"
    }
  }, _vm._l((_vm.dateLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.dateTypeStr,
        "value": item.dateTypeStr
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectTime
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  }, _vm._l((_vm.timeLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.dateDesc,
        "value": item.dateDesc
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传证据"
    }
  }, [_c('div', {
    staticClass: "upload_title"
  }, [_vm._v("注意：上传三证（驾驶证、身份证、行驶证）、身份证国徽面、驾驶证正本反面（带有条形码的一面）需为白色背景")]), _vm._v(" "), _c('ul', {
    staticClass: "upload_case"
  }, [_c('li', {
    staticClass: "upload_item"
  }, [(_vm.threeCard && _vm.threeCard.url) ? _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.threeCard.url)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.threeCard.url, 5)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.threeCard.url)
      }
    }
  })])]) : _c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 5)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("三证")])]), _vm._v(" "), _c('li', {
    staticClass: "upload_item"
  }, [(_vm.backIdCard && _vm.backIdCard.url) ? _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.backIdCard.url)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.backIdCard.url, 6)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.backIdCard.url)
      }
    }
  })])]) : _c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 6)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("身份证国徽面")])]), _vm._v(" "), (_vm.infoData.type == 1) ? _c('li', {
    staticClass: "upload_item"
  }, [(_vm.driverFrontBackCard && _vm.driverFrontBackCard.url) ? _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.driverFrontBackCard.url)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.driverFrontBackCard.url, 10)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.driverFrontBackCard.url)
      }
    }
  })])]) : _c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 10)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("驾驶证正本反面")])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 1) ? _c('li', {
    staticClass: "upload_item"
  }, [(_vm.halfBodyPhoto && _vm.halfBodyPhoto.url) ? _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.halfBodyPhoto.url)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.halfBodyPhoto.url, 22)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.halfBodyPhoto.url)
      }
    }
  })])]) : _c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 22)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("半身照")])]) : _vm._e(), _vm._v(" "), (_vm.infoData.type == 2) ? _c('li', {
    staticClass: "upload_item"
  }, [(_vm.driverBackBackCard && _vm.driverBackBackCard.url) ? _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.driverBackBackCard.url)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-mask"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    on: {
      "click": function($event) {
        return _vm.deleteImg(_vm.driverBackBackCard.url, 13)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.driverBackBackCard.url)
      }
    }
  })])]) : _c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 13)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("驾驶证正页背面")])]) : _vm._e(), _vm._v(" "), (_vm.other.length) ? _vm._l((_vm.other), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "upload_item"
    }, [_c('div', {
      staticClass: "img-box"
    }, [(item.url.indexOf('.mp4') != -1) ? _c('img', {
      attrs: {
        "src": require("../../../assets/images/pics/player.png")
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.getImageUrl(item.url)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.deleteImg(item.url, 4, index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-zoom-in",
      on: {
        "click": function($event) {
          return _vm.previewImg(item.url)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "upload_text"
    }, [_vm._v("其他")])])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "upload_item"
  }, [_c('div', {
    staticClass: "img-box btn_case"
  }, [_c('input', {
    staticClass: "upload-img",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg,.mp4,.MP4"
    },
    on: {
      "change": function($event) {
        return _vm.updateImg($event, 4)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "38px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload_text"
  }, [_vm._v("其他")])])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "驾驶证注册时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "timestamp",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.infoData.driverCardTime),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "driverCardTime", $$v)
      },
      expression: "infoData.driverCardTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "行驶证注册时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "timestamp",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.infoData.vehicleCardTime),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "vehicleCardTime", $$v)
      },
      expression: "infoData.vehicleCardTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否加急"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.infoData.expedited),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "expedited", $$v)
      },
      expression: "infoData.expedited"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.infoData.reporterName),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "reporterName", $$v)
      },
      expression: "infoData.reporterName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.infoData.reportPhone),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "reportPhone", $$v)
      },
      expression: "infoData.reportPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "车辆号码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.infoData.carPlate),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "carPlate", $$v)
      },
      expression: "infoData.carPlate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "驾驶证号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.infoData.driverLicence),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "driverLicence", $$v)
      },
      expression: "infoData.driverLicence"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "btn_case",
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("现在预约")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.onClose()
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de68b740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/components/create.vue
// module id = TTE3
// module chunks = 6